import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import { ThemeSurface } from '@wix/da-react-context/pkg/constants';
import Surface from '@wix/da-ds/pkg/Surface';
import Editor from '../../Editor';
import AttachmentCaptionMenu from '../../../menus/AttachmentCaptionMenu';
import cn from 'classnames';
import { extConfig } from './config';
import viewerStyles from '../../../Viewer/presets/AttachmentCaption/AttachmentCaption.scss';
import s from './AttachmentCaption.scss';
const AttachmentCaptionEditor = (props)=>{
    return /*#__PURE__*/ React.createElement(Surface, {
        className: s['wrapper'],
        type: ThemeSurface.SECONDARY
    }, /*#__PURE__*/ React.createElement(Editor, _object_spread_props(_object_spread({}, props), {
        withinModal: true,
        presetId: "attachment-caption",
        className: cn(s['root'], viewerStyles['root']),
        extensionConfig: extConfig,
        characterCountOptions: {
            limit: 50,
            mode: 'textSize'
        }
    })), /*#__PURE__*/ React.createElement("div", {
        className: cn(s['toolbar'])
    }, /*#__PURE__*/ React.createElement(AttachmentCaptionMenu, null)));
};
AttachmentCaptionEditor.displayName = 'AttachmentCaptionEditor';
export default AttachmentCaptionEditor;

//# sourceMappingURL=AttachmentCaption.js.map